import MuiPhoneNumberInputView from './MuiPhoneNumberInputView';
export default MuiPhoneNumberInputView;
